// Supplementary translations merged on top of i18n.js + i18n_app.js.
// Provides full Arabic (ar) and Simplified Chinese (zh) dictionaries, plus the
// Portuguese (pt) keys missing from the base files. French stays the fallback.

// ── Portuguese — keys missing from the base files ──────────────────────────
const pt = {
  "lost.title": "Perdeu um objeto?",
  "lost.desc": "Escolha como deseja proceder.",
  "lost.b2bTitle": "Declarar num parceiro",
  "lost.b2bDesc": "Perdeu num hotel, num transporte ou num local parceiro? Encontre o estabelecimento e declare a sua perda.",
  "lost.b2cTitle": "Publicar um anúncio público",
  "lost.b2cDesc": "Publique um anúncio visível para todos, ofereça uma recompensa e destaque-o para maximizar as suas hipóteses.",
  "pricing.requestQuote": "Pedir um orçamento",
  "pricing.quoteTitle": "Pedir um orçamento",
  "pricing.quoteOrg": "Organização",
  "pricing.quoteSites": "Número de locais / terminais",
  "pricing.quoteMsg": "A sua necessidade (opcional)",
  "pricing.quoteSend": "Enviar o pedido",
  "pricing.quoteSent": "Pedido enviado! Entraremos em contacto em breve.",
  "trk.lostEmail": "Já não tenho acesso ao meu email",
  "trk.recoverHint": "Receba o seu código de reclamação por SMS no seu número registado.",
  "trk.phonePh": "O seu número de telefone",
  "trk.send": "Enviar",
  "trk.secureRest": "Restituição segura",
  "trk.yourCode": "O seu código de reclamação (a comunicar ao parceiro)",
  "trk.showQr": "Mostre este QR ao parceiro para validar a entrega",
  "trk.codeValidated": "Código validado pelo parceiro",
  "trk.enterEmailCode": "Introduza o seu email acima para ver o seu código de reclamação.",
  "trk.photoBefore": "Foto do objeto antes do envio",
  "trk.signProof": "Assine o seu comprovativo de restituição",
  "trk.signSubmit": "Validar a minha assinatura e gerar o PDF",
  "trk.dlProof": "Descarregar o meu comprovativo de restituição (PDF)",
  "trk.signFirst": "Por favor assine antes de validar.",
  "trk.sigSaved": "Assinatura guardada",
  "pay.howRecover": "Como deseja recuperar o seu objeto?",
  "pay.pickup": "Recuperar em mãos",
  "pay.pickupDesc": "Em",
  "pay.free": "grátis",
  "pay.ship": "Enviar-me o objeto",
  "pay.shipDesc": "Entrega na minha morada",
  "pay.shipping": "Custos de envio",
  "pay.addrIncomplete": "Por favor indique a sua morada de entrega.",
  "pay.addr1": "Morada",
  "pay.addr2": "Complemento de morada (opcional)",
  "pay.postal": "Código postal",
  "pay.city": "Cidade",
  "pay.country": "País",
  "a.rememberMe": "Lembrar-me",
  "a.city": "Cidade",
  "a.category": "Categoria",
  "a.categoryPlaceholder": "Escolher uma categoria",
  "a.siret": "SIRET",
  "a.vat": "N.º de IVA intracom.",
  "a.legalHint": "Obrigatório para a faturação eletrónica (Factur-X) dos estabelecimentos franceses.",
  "a.legalRequiredFR": "O SIRET e o número de IVA intracomunitário são obrigatórios para a França.",
  "pcat.hotel": "Hotéis",
  "pcat.restaurant": "Restaurantes",
  "pcat.park": "Parques",
  "pcat.city_hall": "Câmaras municipais",
  "pcat.prefecture": "Prefeituras",
  "pcat.other": "Outro",
  "pcat.uncategorized": "Sem categoria",
  "mc.rememberMe": "Lembrar-me",
  "mc.forgotLink": "Esqueceu-se da palavra-passe?",
  "mc.forgotTitle": "Palavra-passe esquecida",
  "mc.forgotSend": "Enviar o link",
  "mc.forgotSent": "Se existir uma conta para este email, foi enviado um link de redefinição.",
  "mc.backToLogin": "Voltar ao início de sessão",
  "mc.resetTitle": "Nova palavra-passe",
  "mc.resetSave": "Redefinir a minha palavra-passe",
  "mc.resetDone": "Palavra-passe atualizada. Já pode iniciar sessão.",
  "mc.newPassword": "Nova palavra-passe",
  "mc.confirmPassword": "Confirmar a palavra-passe",
  "mc.passwordMismatch": "As palavras-passe não coincidem.",
  "mc.resetExpired": "Este link de redefinição é inválido ou expirou. Peça um novo abaixo.",
  "nav.ranking": "Classificação",
  "mc.scoreTitle": "Pontuação de Achador",
  "mc.scorePts": "pts",
  "mc.scoreThisYear": "Este ano",
  "mc.seeRanking": "Ver a classificação",
  "mc.confirmRestitution": "Confirmar a restituição",
  "mc.restitutionConfirmed": "Restituição confirmada.",
  "mc.scoreAwarded": "Parabéns! +1 na sua Pontuação de Achador 🎉",
  "mc.scoreEarned": "Ponto obtido",
  "mc.finderProfile": "Perfil de achador (opcional)",
  "mc.finderProfileDesc": "Ganhe pontos ao restituir objetos e apareça na classificação pública.",
  "mc.addPhoto": "Adicionar uma foto",
  "mc.remove": "Remover",
  "mc.pseudo": "Nome próprio ou pseudónimo",
  "mc.city": "Cidade",
  "mc.optInTitle": "Aparecer na classificação pública",
  "mc.optInDesc": "Participação opcional. Consente em exibir publicamente os elementos escolhidos abaixo. Alterável a qualquer momento.",
  "mc.visLabel": "Elementos visíveis na classificação:",
  "mc.visPhoto": "Foto de perfil",
  "mc.visName": "Nome / pseudónimo",
  "mc.visCity": "Cidade",
  "mc.visCountry": "País",
  "mc.profileSettings": "Perfil público e classificação",
  "mc.profileSaved": "Perfil atualizado.",
  "lb.badge": "Classificação anual",
  "lb.title": "Os melhores achadores",
  "lb.subtitle": "Cada restituição rende pontos. A classificação é reiniciada a cada 1 de janeiro.",
  "lb.tabFinders": "Achadores",
  "lb.tabPartners": "Estabelecimentos",
  "lb.allCountries": "Todos os países",
  "lb.cityPh": "Filtrar por cidade…",
  "lb.empty": "Nenhuma classificação para estes filtros de momento.",
  "lb.pts": "pontos",
  "lb.returned": "restituídos",
  "lb.resetNote": "Classificação do ano em curso — reiniciada a 1 de janeiro.",
  "fp.backToRanking": "Voltar à classificação",
  "fp.notFound": "Perfil não encontrado ou privado.",
  "fp.badge": "Distintivo",
  "fp.scoreYear": "Pontos em",
  "fp.scoreTotal": "Pontos acumulados",
  "fp.tagline": "Um achador honesto que torna o mundo melhor.",
  "fp.share": "Partilhar este perfil",
  "fp.shareText": "Descubra o perfil de {name}, achador Findloop!",
  "lb.share": "Partilhar a classificação",
  "lb.shareText": "Descubra a classificação dos melhores achadores no Findloop!",
  "lb.champion": "🏆 Campeão do ano",
  "mc.pointsBalance": "Pontos a trocar",
  "mc.rewardsTitle": "Trocar os meus pontos",
  "mc.rewardsDesc": "Use os seus pontos por vantagens oferecidas pelos nossos parceiros. Saldo:",
  "mc.rewardsNone": "Nenhuma recompensa disponível de momento.",
  "mc.redeem": "Trocar",
  "mc.notEnough": "Pontos insuficientes",
  "mc.rewardRedeemed": "Recompensa obtida! Código:",
  "mc.myRewards": "Os meus vouchers obtidos",
  "mc.redUsed": "Utilizado",
  "mc.redReady": "A apresentar",
  "mc.redExpired": "Expirado",
  "mc.expiresOn": "Expira a",
  "mc.historyTitle": "Histórico dos meus pontos",
  "mc.histEarned": "Objeto restituído",
  "mc.notifTitle": "Notificações",
  "mc.notifEmpty": "Nenhuma notificação de momento.",
  "home.champTitle": "Os nossos melhores achadores",
  "home.champSubtitle": "Cada objeto restituído rende pontos. Junte-se à classificação e ganhe recompensas.",
  "home.champCta": "Ver a classificação",
  "home.champBecome": "Tornar-se achador",
  "map.filterCity": "Cidade ou país…",
  "map.allCategories": "Todas as categorias",
  "map.clear": "Repor",
  "map.fullscreen": "Ecrã inteiro",
  "map.exitFullscreen": "Sair",
  "map.topPlaces": "Locais populares",
  "map.heatmap": "Mapa de calor",
  "map.stats": "Estatísticas por cidade",
  "map.statsTop": "Top 5 dos locais (objetos perdidos)",
  "map.statsTrend": "Evolução em 6 meses",
  "map.periodAll": "Todo o período",
  "map.period7": "Últimos 7 dias",
  "map.period30": "Últimos 30 dias",
  "map.period90": "Últimos 90 dias",
  "map.impactMonth": "objetos restituídos este mês",
  "map.impactTotal": "restituídos no total",
  "pd.back": "Todos os parceiros",
  "pd.declare": "Declarar uma perda aqui",
  "pd.reviews": "Avaliações de clientes",
  "pd.noReviews": "Nenhuma avaliação de momento.",
  "pd.itemsReturned": "objetos restituídos",
  "pd.itemsTotal": "objetos registados",
  "pd.certified": "Parceiro certificado",
  "pd.about": "Sobre",
  "pd.notFound": "Parceiro não encontrado.",
  "pd.verifiedEstablishment": "Estabelecimento verificado Findloop",
  "mc.privacy": "Privacidade e dados",
  "mc.privacyDesc": "Descarregue uma cópia de todos os seus dados pessoais conservados pelo Findloop (RGPD, art. 15 e 20).",
  "mc.exportData": "Descarregar os meus dados (RGPD)",
  "mc.exporting": "A preparar…",
  "mc.exportDone": "Os seus dados foram descarregados.",
  "pd.map": "Localização",
  "pd.recentItems": "Últimos objetos encontrados",
  "pd.noItems": "Nenhum objeto encontrado recentemente.",
  "pd.verified": "Avaliação verificada",
  "pd.reply": "Resposta do estabelecimento",
  "mc.deleteAccount": "Eliminar a minha conta",
  "mc.deleteDesc": "Elimina definitivamente a sua conta e anonimiza os seus dados pessoais. Esta ação é irreversível.",
  "mc.deleteConfirmTitle": "Eliminar a sua conta?",
  "mc.deleteConfirmBody": "A sua conta será eliminada definitivamente e os seus dados pessoais anonimizados. Esta ação não pode ser anulada.",
  "mc.deleteConfirm": "Sim, eliminar a minha conta",
  "mc.deleting": "A eliminar…",
  "mc.deleted": "A sua conta foi eliminada.",
  "mc.cancel": "Cancelar",
};

// ── Arabic (RTL) — full dictionary ─────────────────────────────────────────
const ar = {
  // marketing
  "rev.eyebrow": "شهادات",
  "rev.title": "يثقون في Findloop",
  "rev.subtitle": "شركاؤنا وعملاؤنا يشاركون تجربتهم.",
  "rev.b2b": "الشركاء B2B",
  "rev.b2c": "العملاء",
  "rev.verified": "موثّق",
  "rev.based": "من {n} تقييم",
  "nav.partners": "الشركاء",
  "nav.track": "تتبّع بلاغًا",
  "nav.how": "كيف يعمل",
  "nav.pricing": "الأسعار",
  "nav.login": "تسجيل الدخول",
  "nav.register": "كن شريكًا",
  "nav.dashboard": "مساحتي",
  "hero.badge": "مميّز",
  "hero.title": "كل غرض مفقود يعود إلى صاحبه.",
  "hero.subtitle": "يساعد Findloop المؤسسات على إدارة الأغراض المفقودة — ويتيح لعملائها الإبلاغ عن فقدان ثم استعادة أغراضهم، في المكان أو عبر الشحن.",
  "hero.ctaPartner": "كن شريكًا",
  "hero.ctaLost": "فقدت غرضًا",
  "hero.ctaFound": "عثرت على غرض",
  "lost.title": "هل فقدت غرضًا؟",
  "lost.desc": "اختر الطريقة التي تريد المتابعة بها.",
  "lost.b2bTitle": "الإبلاغ لدى شريك",
  "lost.b2bDesc": "فقدته في فندق أو وسيلة نقل أو مكان شريك؟ ابحث عن المؤسسة وأبلغ عن فقدانك.",
  "lost.b2cTitle": "نشر إعلان عام",
  "lost.b2cDesc": "انشر إعلانًا مرئيًا للجميع، وقدّم مكافأة وروّجه لزيادة فرصك.",
  "stat.partners": "الشركاء",
  "stat.items": "الأغراض المسجّلة",
  "stat.restituted": "الأغراض المُعادة",
  "how.eyebrow": "كيف يعمل",
  "how.title": "من الإيداع إلى الاستعادة، بكل بساطة.",
  "step1.tag": "المؤسسة",
  "step1.title": "الشريك يسجّل الغرض",
  "step1.text": "خلال ثوانٍ، تودع المؤسسة الغرض الموجود مع صورة وفئة ووصف. كل شيء مركزي في سجل واضح وآمن.",
  "step2.tag": "العميل",
  "step2.title": "العميل يبلّغ عن فقدانه",
  "step2.text": "عبر رمز QR الخاص بالشريك، يصف عميلك الغرض المفقود في 30 ثانية. لا حاجة لتثبيت تطبيق، كل شيء يتم في المتصفح.",
  "step3.tag": "الذكاء",
  "step3.title": "الذكاء الاصطناعي يربط بين المفقود والموجود",
  "step3.text": "يقارن محرك المطابقة الذكي لدينا الأوصاف ويقترح التطابقات الأكثر احتمالًا، جاهزة للتأكيد.",
  "step4.tag": "الاستعادة",
  "step4.title": "العميل يستعيد غرضه",
  "step4.text": "بعد دفع آمن لرسوم الاستعادة، يأتي العميل لأخذ غرضه في المكان — أو يستلمه عبر شحن متتبَّع.",
  "promo.badge": "برنامج الشركاء",
  "promo.title": "أحِل غيرك واحصل على شهر مجاني.",
  "promo.text": "كل شريك تحيله ويشترك يمنحك شهرًا مجانيًا. بلا حدود.",
  "promo.cta": "اعرف المزيد",
  "feat1.t": "لوحة تحكم وتحليلات",
  "feat1.d": "مؤشرات الأداء، معدل الاستعادة حسب الفئة، الإيرادات والاتجاهات خلال 30 يومًا.",
  "feat2.t": "وحدة الشحن",
  "feat2.d": "ملصقات، تتبّع الناقل ورسائل تتبّع تلقائية.",
  "feat3.t": "دليل عام وتقييمات",
  "feat3.d": "يجدك عملاؤك حسب المدينة والفئة، مع تقييمات موثّقة.",
  "pricing.eyebrow": "الأسعار",
  "pricing.title": "عرض لكل مؤسسة",
  "pricing.subtitle": "ابدأ مجانًا، وتطوّر حسب احتياجاتك.",
  "pricing.popular": "الأكثر شيوعًا",
  "pricing.choose": "اختيار",
  "pricing.start": "ابدأ",
  "pricing.month": "/شهر",
  "pricing.requestQuote": "طلب عرض سعر",
  "pricing.quoteTitle": "طلب عرض سعر",
  "pricing.quoteOrg": "المؤسسة",
  "pricing.quoteSites": "عدد المواقع / الأجهزة",
  "pricing.quoteMsg": "حاجتك (اختياري)",
  "pricing.quoteSend": "إرسال الطلب",
  "pricing.quoteSent": "تم إرسال الطلب! سنتواصل معك قريبًا.",
  "pricing.compareTitle": "قارن بين الباقات",
  "pricing.compareFeature": "الميزة",
  "cmp.estIncl": "المؤسسات المشمولة",
  "cmp.estSec": "مؤسسة إضافية",
  "cmp.items": "الأغراض / الشهر",
  "cmp.ai": "المطابقة بالذكاء الاصطناعي",
  "cmp.stats": "الإحصاءات",
  "cmp.autobill": "الفوترة التلقائية",
  "cmp.members": "دعوات الأعضاء",
  "cmp.consol": "فوترة موحّدة",
  "cmp.deploy": "نشر مخصّص واتفاقية مستوى الخدمة",
  "cmp.support": "الدعم",
  "cmp.main": "1 رئيسي",
  "cmp.upTo3": "حتى 3",
  "cmp.unlimited": "غير محدود",
  "cmp.onQuote": "حسب العرض",
  "cmp.max20": "20 كحد أقصى",
  "cmp.basic": "أساسي",
  "cmp.adv": "متقدّم",
  "cmp.statsBasic": "أساسية",
  "cmp.statsAdv": "متقدّمة",
  "cmp.custom": "مخصّص",
  "cmp.community": "المجتمع",
  "cmp.priority": "ذو أولوية",
  "cmp.dedicated": "مخصّص",
  "cta.title": "مستعد لتقليل الأغراض المفقودة؟",
  "cta.subtitle": "انضم إلى المؤسسات التي تعيد الأغراض بشكل أسرع بفضل findloop.",
  "cta.button": "إنشاء حساب شريك",
  "lang.label": "اللغة",
  "nav.more": "المزيد",
  // app — common / declaration
  "c.loading": "جارٍ التحميل…",
  "c.reviews": "تقييم",
  "c.save": "حفظ",
  "c.cancel": "إلغاء",
  "dec.notfound": "الشريك غير موجود.",
  "dec.home": "العودة إلى الرئيسية",
  "dec.badge": "بلاغ فقدان",
  "dec.successTitle": "تم إرسال البلاغ!",
  "dec.successText": "نبحث عن غرضك بين ما تم إيداعه لدى",
  "dec.matchFound": "تم بالفعل تحديد تطابق!",
  "dec.trackBtn": "تتبّع بلاغي",
  "dec.recoverBtn": "استعادة غرضي",
  "dec.category": "فئة الغرض",
  "dec.description": "الوصف",
  "dec.descPh": "صف الغرض: الماركة، اللون، العلامات المميزة…",
  "dec.date": "تاريخ الفقدان",
  "dec.place": "مكان الفقدان",
  "dec.placePh": "مثال: في البار، الغرفة 204…",
  "dec.contactTitle": "بيانات التواصل",
  "dec.name": "الاسم الكامل",
  "dec.email": "البريد الإلكتروني",
  "dec.phone": "الهاتف",
  "dec.submit": "إرسال بلاغي",
  "dec.submitting": "جارٍ الإرسال…",
  "par.badge": "الدليل",
  "par.title": "شركاؤنا",
  "par.subtitle": "ابحث عن المؤسسة التي فقدت فيها غرضك وأبلغ عن فقدانك.",
  "par.searchPh": "ابحث عن مؤسسة…",
  "par.allCountries": "كل الدول",
  "par.certified": "معتمدون",
  "par.none": "لم يتم العثور على أي شريك.",
  "par.certifiedBadge": "معتمد",
  "par.partnerBadge": "شريك",
  "par.declare": "الإبلاغ",
  "trk.badge": "التتبّع",
  "trk.title": "تتبّع بلاغي",
  "trk.subtitle": "أدخل رقم بلاغك لمتابعة التقدّم.",
  "trk.idLabel": "رقم البلاغ",
  "trk.emailLabel": "البريد الإلكتروني (اختياري — لعرض بياناتك)",
  "trk.submit": "تتبّع",
  "trk.searching": "جارٍ البحث…",
  "trk.at": "لدى",
  "trk.recoverBtn": "استعادة غرضي",
  "trk.lostEmail": "لم يعد لدي وصول إلى بريدي الإلكتروني",
  "trk.recoverHint": "احصل على رمز المطالبة عبر رسالة نصية على رقمك المسجّل.",
  "trk.phonePh": "رقم هاتفك",
  "trk.send": "إرسال",
  "trk.secureRest": "استعادة آمنة",
  "trk.yourCode": "رمز المطالبة الخاص بك (أطلعه للشريك)",
  "trk.showQr": "أظهر رمز QR هذا للشريك للتحقق من التسليم",
  "trk.codeValidated": "تم التحقق من الرمز من قبل الشريك",
  "trk.enterEmailCode": "أدخل بريدك الإلكتروني أعلاه لعرض رمز المطالبة.",
  "trk.photoBefore": "صورة الغرض قبل الشحن",
  "trk.signProof": "وقّع إثبات الاستعادة",
  "trk.signSubmit": "تأكيد توقيعي وإنشاء PDF",
  "trk.dlProof": "تحميل إثبات الاستعادة (PDF)",
  "trk.signFirst": "يرجى التوقيع قبل التأكيد.",
  "trk.sigSaved": "تم حفظ التوقيع",
  "pay.badge": "الاستعادة",
  "pay.title": "استعادة غرضي",
  "pay.subtitleWith": "ادفع رسوم الاستعادة لدى",
  "pay.fee": "رسوم الاستعادة",
  "pay.serviceFee": "رسوم خدمة Findloop",
  "pay.total": "الإجمالي",
  "pay.shipNote": "الشحن ممكن",
  "pay.shipAfter": "— يُقترح بعد الدفع.",
  "pay.noMatch": "لم يتم بعد تأكيد أي غرض مطابق لهذا البلاغ.",
  "pay.card": "الدفع بالبطاقة",
  "pay.momo": "الدفع عبر Mobile Money",
  "pay.momoConfirm": "تأكيد الدفع",
  "pay.phonePh": "رقم الهاتف",
  "pay.secure": "دفع آمن",
  "pay.notfound": "البلاغ غير موجود.",
  "pay.howRecover": "كيف تريد استعادة غرضك؟",
  "pay.pickup": "الاستلام باليد",
  "pay.pickupDesc": "لدى",
  "pay.free": "مجاني",
  "pay.ship": "شحن الغرض إليّ",
  "pay.shipDesc": "التوصيل إلى عنواني",
  "pay.shipping": "رسوم الشحن",
  "pay.addrIncomplete": "يرجى إدخال عنوان التوصيل.",
  "pay.addr1": "العنوان",
  "pay.addr2": "تكملة العنوان (اختياري)",
  "pay.postal": "الرمز البريدي",
  "pay.city": "المدينة",
  "pay.country": "الدولة",
  "rate.title": "قيّم تجربتك",
  "rate.subtitle": "كيف كانت عملية استعادة غرضك؟",
  "rate.commentPh": "تعليق (اختياري)…",
  "rate.submit": "إرسال تقييمي",
  "rate.submitting": "جارٍ الإرسال…",
  "rate.successTitle": "شكرًا على تقييمك!",
  "rate.successText": "ملاحظاتك تساعد المستخدمين الآخرين.",
  "rate.home": "العودة إلى الرئيسية",
  "rate.chooseNote": "اختر تقييمًا.",
  // app — auth
  "a.email": "البريد الإلكتروني",
  "a.password": "كلمة المرور",
  "a.confirmPassword": "تأكيد كلمة المرور",
  "a.passwordMismatch": "كلمتا المرور غير متطابقتين.",
  "a.loginTitle": "دخول الشريك",
  "a.loginSub": "ادخل إلى مساحة الإدارة الخاصة بك.",
  "a.login": "تسجيل الدخول",
  "a.loggingIn": "جارٍ الدخول…",
  "a.forgot": "نسيت؟",
  "a.or": "أو",
  "a.rememberMe": "تذكّرني",
  "a.noAccount": "لست شريكًا بعد؟",
  "a.createAccount": "إنشاء حساب",
  "a.registerTitle": "كن شريكًا",
  "a.registerSub": "أنشئ مساحتك في دقيقة — مجانية للبدء.",
  "a.org": "اسم المؤسسة",
  "a.emailPro": "البريد الإلكتروني المهني",
  "a.country": "الدولة",
  "a.city": "المدينة",
  "a.category": "الفئة",
  "a.categoryPlaceholder": "اختر فئة",
  "a.siret": "SIRET",
  "a.vat": "رقم ضريبة القيمة المضافة",
  "a.legalHint": "إلزامي للفوترة الإلكترونية (Factur-X) للمؤسسات الفرنسية.",
  "a.legalRequiredFR": "رقم SIRET ورقم ضريبة القيمة المضافة إلزاميان لفرنسا.",
  "pcat.hotel": "فنادق",
  "pcat.restaurant": "مطاعم",
  "pcat.park": "حدائق",
  "pcat.city_hall": "بلديات",
  "pcat.prefecture": "محافظات",
  "pcat.other": "أخرى",
  "pcat.uncategorized": "غير مصنّف",
  "a.referral": "رمز الإحالة (اختياري)",
  "a.createBtn": "إنشاء حسابي",
  "a.creating": "جارٍ الإنشاء…",
  "a.haveAccount": "شريك بالفعل؟",
  "a.signin": "تسجيل الدخول",
  "a.googleContinue": "المتابعة عبر Google",
  "a.googleSignup": "التسجيل عبر Google",
  "a.forgotTitle": "نسيت كلمة المرور",
  "a.forgotSub": "احصل على رابط إعادة تعيين عبر البريد الإلكتروني.",
  "a.sendLink": "إرسال الرابط",
  "a.sending": "جارٍ الإرسال…",
  "a.back": "رجوع",
  "a.forgotSent": "إذا كان هناك حساب، فقد تم إرسال رابط إعادة التعيين للتو.",
  "a.resetTitle": "كلمة مرور جديدة",
  "a.resetSub": "اختر كلمة مرور جديدة لحسابك.",
  "a.newPassword": "كلمة المرور الجديدة",
  "a.reset": "إعادة التعيين",
  "a.min6": "6 أحرف كحد أدنى",
  // app — dashboard
  "db.registry.t": "سجل الأغراض",
  "db.registry.s": "كل الأغراض الموجودة المودعة في مؤسستك.",
  "db.deposit.t": "إيداع غرض موجود",
  "db.deposit.s": "أضف صورة وفئة ووصفًا.",
  "db.declarations.t": "بلاغات الفقدان",
  "db.declarations.s": "العملاء الذين أبلغوا عن غرض مفقود عبر رمز QR الخاص بك.",
  "db.stats.t": "الإحصاءات",
  "db.stats.s": "مؤشرات الأداء الرئيسية لديك.",
  "db.team.t": "الفريق",
  "db.team.s": "ادعُ زملاءك لإدارة الأغراض.",
  "db.account.t": "حسابي",
  "db.account.s": "أدر مؤسستك واشتراكك ورمز QR.",
  "side.registry": "السجل",
  "side.deposit": "إيداع غرض",
  "side.declarations": "البلاغات",
  "side.stats": "الإحصاءات",
  "side.team": "الفريق",
  "side.account": "حسابي",
  "side.matchHistory": "سجل الذكاء الاصطناعي",
  "side.viewSite": "عرض الموقع العام",
  "side.logout": "تسجيل الخروج",
  "side.partner": "شريك",
  "cat.placeholder": "اختر فئة",
  "shell.title": "حوّل الأغراض المفقودة إلى عملاء راضين.",
  "shell.f1t": "مطابقة ذكية بالذكاء الاصطناعي",
  "shell.f1d": "اربط تلقائيًا بين الأغراض المفقودة والموجودة.",
  "shell.f2t": "لوحة تحكم وإيرادات",
  "shell.f2d": "تابع معدل الاستعادة والإيرادات في الوقت الفعلي.",
  "shell.f3t": "رمز QR للشريك",
  "shell.f3d": "يبلّغ عملاؤك في 30 ثانية.",
  "cover.title": "صورة الغلاف",
  "cover.helper": "تظهر كبانر في صفحة البلاغ وفي الدليل.",
  "cover.none": "لا توجد صورة غلاف",
  "cover.add": "إضافة",
  "cover.change": "تغيير",
  "cover.remove": "حذف",
  "crop.title": "قص صورة الغلاف",
  "crop.desc": "اضبط الإطار بصيغة البانر (3:1). اسحب وكبّر.",
  "crop.saving": "جارٍ الحفظ…",
  // app — client account (mc)
  "mc.title": "حسابي",
  "mc.subtitle": "تابع كل بلاغاتك في مكان واحد.",
  "mc.loginTitle": "دخول العميل",
  "mc.registerTitle": "إنشاء حساب عميل",
  "mc.name": "الاسم الكامل",
  "mc.email": "البريد الإلكتروني",
  "mc.phone": "الهاتف",
  "mc.password": "كلمة المرور",
  "mc.country": "الدولة",
  "mc.loginBtn": "تسجيل الدخول",
  "mc.registerBtn": "إنشاء حسابي",
  "mc.toRegister": "ليس لديك حساب بعد؟",
  "mc.toLogin": "مسجّل بالفعل؟",
  "mc.rememberMe": "تذكّرني",
  "mc.forgotLink": "نسيت كلمة المرور؟",
  "mc.forgotTitle": "نسيت كلمة المرور",
  "mc.forgotSend": "إرسال الرابط",
  "mc.forgotSent": "إذا كان هناك حساب لهذا البريد، فقد تم إرسال رابط إعادة تعيين.",
  "mc.backToLogin": "العودة إلى تسجيل الدخول",
  "mc.resetTitle": "كلمة مرور جديدة",
  "mc.resetSave": "إعادة تعيين كلمة المرور",
  "mc.resetDone": "تم تحديث كلمة المرور. يمكنك تسجيل الدخول.",
  "mc.newPassword": "كلمة المرور الجديدة",
  "mc.confirmPassword": "تأكيد كلمة المرور",
  "mc.passwordMismatch": "كلمتا المرور غير متطابقتين.",
  "mc.resetExpired": "رابط إعادة التعيين غير صالح أو منتهٍ. اطلب رابطًا جديدًا أدناه.",
  "mc.logout": "تسجيل الخروج",
  "mc.welcome": "مرحبًا",
  "mc.myDeclarations": "بلاغاتي",
  "mc.none": "لا توجد بلاغات حاليًا.",
  "mc.track": "تتبّع",
  "mc.at": "لدى",
  // app — shipping (ship)
  "ship.badge": "الشحن",
  "ship.title": "شحن الغرض إليّ",
  "ship.subtitle": "أدخل عنوان التوصيل الخاص بك.",
  "ship.notShippable": "هذا الغرض غير متاح للشحن.",
  "ship.needPaid": "ادفع أولًا رسوم الاستعادة لطلب الشحن.",
  "ship.addr1": "العنوان",
  "ship.addr2": "تكملة العنوان (اختياري)",
  "ship.postal": "الرمز البريدي",
  "ship.city": "المدينة",
  "ship.country": "الدولة",
  "ship.weight": "الوزن التقديري (كجم)",
  "ship.submit": "طلب الشحن",
  "ship.submitting": "جارٍ الإرسال…",
  "ship.price": "رسوم الشحن",
  "ship.successTitle": "تم إرسال طلب الشحن!",
  "ship.successText": "سيجهّز الشريك طردك. ستُخطر عند الإرسال.",
  "ship.notfound": "البلاغ غير موجود.",
  "db.reviews.t": "تقييمات العملاء",
  "db.reviews.s": "أجب علنًا على تقييمات عملائك.",
  "db.shipments.t": "الشحنات",
  "db.shipments.s": "أنشئ الملصقات وتابع الطرود المراد إرسالها.",
  "side.reviews": "تقييمات العملاء",
  "side.shipments": "الشحنات",
  "side.invoices": "الفواتير",
  "side.refresh": "تحديث",
  // app — invoices
  "inv.title": "فواتيري",
  "inv.subtitle": "اطّلع على فواتيرك وإيصالاتك وحمّلها.",
  "inv.count": "الفواتير",
  "inv.paid": "مدفوع (€)",
  "inv.unpaid": "غير مدفوع (€)",
  "inv.empty": "لا توجد فواتير حاليًا.",
  "inv.issued": "صدرت في",
  "inv.due": "الاستحقاق",
  "inv.paidOn": "دُفعت في",
  "inv.statusPaid": "مدفوعة",
  "inv.statusUnpaid": "غير مدفوعة",
  "inv.invoicePdf": "الفاتورة PDF",
  "inv.receipt": "إيصال",
  "inv.pay": "دفع",
  "inv.all": "الكل",
  "inv.allYears": "كل السنوات",
  "inv.noMatch": "لا توجد فاتورة لهذا الفلتر.",
  "inv.exportCsv": "تصدير CSV",
  "inv.reminders": "التذكيرات",
  "inv.remindersDesc": "تذكيرات البريد الإلكتروني والرسائل النصية المرسلة لهذه الفاتورة.",
  "inv.remindersEmpty": "لم يتم إرسال أي تذكير.",
  "inv.rmDue": "تذكير عند الاستحقاق",
  "inv.rmManual": "تذكير يدوي",
  "inv.rmSms": "تذكير SMS بعد 30 يومًا",
  "inv.rmStage": "تذكير",
  // app — partner reviews / shipments
  "prev.none": "لا توجد تقييمات حاليًا.",
  "prev.reply": "الرد",
  "prev.editReply": "تعديل الرد",
  "prev.yourReply": "ردّك",
  "prev.send": "نشر الرد",
  "prev.sending": "جارٍ النشر…",
  "prev.replyPh": "اكتب ردًا مهذبًا…",
  "prev.published": "تم نشر الرد",
  "shp.none": "لم يُطلب أي شحن.",
  "shp.to": "المستلم",
  "shp.label": "إنشاء الملصق",
  "shp.download": "تحميل PDF",
  "shp.tracking": "رقم التتبّع",
  "shp.carrier": "الناقل",
  "shp.setTracking": "حفظ التتبّع",
  "shp.status": "الحالة",
  "shp.generating": "جارٍ الإنشاء…",
  "shp.trackingSaved": "تم حفظ التتبّع",
  "pr.shipBtn": "شحن الغرض إليّ",
  "mc.myFound": "الأغراض الموجودة المُبلّغ عنها",
  "mc.myAds": "إعلانات الفقدان الخاصة بي",
  "mc.foundNone": "لا يوجد غرض موجود مُبلّغ عنه.",
  "mc.adsNone": "لا توجد إعلانات فقدان.",
  "mc.reward": "مكافأة",
  "mc.foundAt": "وُجد في",
  "mc.lostAt": "فُقد في",
  // app — statuses
  "st.in_storage": "في الإيداع",
  "st.matched": "تطابق",
  "st.paid": "مدفوع",
  "st.shipping_requested": "طُلب الشحن",
  "st.shipped": "تم الشحن",
  "st.restituted": "أُعيد",
  "st.pending": "قيد الانتظار",
  "st.submitted": "مُرسل",
  "st.open": "مفتوح",
  "st.claimed": "مُطالَب به",
  "st.verified": "موثّق",
  "st.second_chance": "فرصة ثانية",
  "st.delivered": "تم التسليم",
  "st.closed": "مغلق",
  "st.resolved": "محلول",
  "st.destroyed": "مُتلَف",
  "st.donated": "مُتبرَّع به (جمعية)",
  "st.auctioned": "بيع بالمزاد",
  "st.handed_to_authorities": "سُلّم للسلطات",
  "nav.ads": "الأغراض المفقودة",
  "nav.map": "الخريطة",
  "nav.ranking": "التصنيف",
  // app — score / finder
  "mc.scoreTitle": "نقاط الواجد",
  "mc.scorePts": "نقطة",
  "mc.scoreThisYear": "هذا العام",
  "mc.seeRanking": "عرض التصنيف",
  "mc.confirmRestitution": "تأكيد الاستعادة",
  "mc.restitutionConfirmed": "تم تأكيد الاستعادة.",
  "mc.scoreAwarded": "أحسنت! +1 لنقاط الواجد 🎉",
  "mc.scoreEarned": "تم الحصول على نقطة",
  "mc.finderProfile": "ملف الواجد (اختياري)",
  "mc.finderProfileDesc": "اكسب نقاطًا بإعادة الأغراض وظهورك في التصنيف العام.",
  "mc.addPhoto": "إضافة صورة",
  "mc.remove": "إزالة",
  "mc.pseudo": "الاسم أو اللقب",
  "mc.city": "المدينة",
  "mc.optInTitle": "الظهور في التصنيف العام",
  "mc.optInDesc": "مشاركة اختيارية. أنت توافق على عرض العناصر المختارة أدناه علنًا. قابلة للتعديل في أي وقت.",
  "mc.visLabel": "العناصر المرئية في التصنيف:",
  "mc.visPhoto": "صورة الملف الشخصي",
  "mc.visName": "الاسم / اللقب",
  "mc.visCity": "المدينة",
  "mc.visCountry": "الدولة",
  "mc.profileSettings": "الملف العام والتصنيف",
  "mc.profileSaved": "تم تحديث الملف.",
  "lb.badge": "التصنيف السنوي",
  "lb.title": "أفضل الواجدين",
  "lb.subtitle": "كل استعادة تمنح نقاطًا. يُعاد ضبط التصنيف كل 1 يناير.",
  "lb.tabFinders": "الواجدون",
  "lb.tabPartners": "المؤسسات",
  "lb.allCountries": "كل الدول",
  "lb.cityPh": "تصفية حسب المدينة…",
  "lb.empty": "لا يوجد تصنيف لهذه الفلاتر حاليًا.",
  "lb.pts": "نقطة",
  "lb.returned": "مُعادة",
  "lb.resetNote": "تصنيف العام الحالي — يُعاد ضبطه في 1 يناير.",
  "fp.backToRanking": "العودة إلى التصنيف",
  "fp.notFound": "الملف غير موجود أو خاص.",
  "fp.badge": "شارة",
  "fp.scoreYear": "النقاط في",
  "fp.scoreTotal": "النقاط التراكمية",
  "fp.tagline": "واجد أمين يجعل العالم أفضل.",
  "fp.share": "مشاركة هذا الملف",
  "fp.shareText": "اكتشف ملف {name}، واجد Findloop!",
  "lb.share": "مشاركة التصنيف",
  "lb.shareText": "اكتشف تصنيف أفضل الواجدين على Findloop!",
  "lb.champion": "🏆 بطل العام",
  "mc.pointsBalance": "نقاط للاستبدال",
  "mc.rewardsTitle": "استبدال نقاطي",
  "mc.rewardsDesc": "استخدم نقاطك للحصول على مزايا يقدّمها شركاؤنا. الرصيد:",
  "mc.rewardsNone": "لا توجد مكافآت متاحة حاليًا.",
  "mc.redeem": "استبدال",
  "mc.notEnough": "نقاط غير كافية",
  "mc.rewardRedeemed": "تم الحصول على المكافأة! الرمز:",
  "mc.myRewards": "قسائمي المكتسبة",
  "mc.redUsed": "مستخدَم",
  "mc.redReady": "للتقديم",
  "mc.redExpired": "منتهٍ",
  "mc.expiresOn": "ينتهي في",
  "mc.historyTitle": "سجل نقاطي",
  "mc.histEarned": "غرض مُعاد",
  "mc.notifTitle": "الإشعارات",
  "mc.notifEmpty": "لا توجد إشعارات حاليًا.",
  "home.champTitle": "أفضل الواجدين لدينا",
  "home.champSubtitle": "كل غرض مُعاد يمنح نقاطًا. انضم إلى التصنيف واكسب مكافآت.",
  "home.champCta": "عرض التصنيف",
  "home.champBecome": "كن واجدًا",
  // app — map
  "map.filterCity": "مدينة أو دولة…",
  "map.allCategories": "كل الفئات",
  "map.clear": "إعادة الضبط",
  "map.fullscreen": "ملء الشاشة",
  "map.exitFullscreen": "خروج",
  "map.topPlaces": "الأماكن الشائعة",
  "map.heatmap": "خريطة حرارية",
  "map.stats": "إحصاءات حسب المدينة",
  "map.statsTop": "أفضل 5 أماكن (أغراض مفقودة)",
  "map.statsTrend": "التطور خلال 6 أشهر",
  "map.periodAll": "كل الفترات",
  "map.period7": "آخر 7 أيام",
  "map.period30": "آخر 30 يومًا",
  "map.period90": "آخر 90 يومًا",
  "map.impactMonth": "أغراض مُعادة هذا الشهر",
  "map.impactTotal": "مُعادة إجمالًا",
  // app — events
  "ev.created": "تم إنشاء البلاغ",
  "ev.matched": "تم تحديد غرض مطابق",
  "ev.paid": "تم دفع رسوم الاستعادة",
  "ev.shipping_requested": "طُلب الشحن",
  "ev.shipping_paid": "تم دفع رسوم الشحن",
  "ev.shipped": "تم شحن الطرد",
  "ev.pickup": "الاستلام في المكان",
  // app — announcements (an)
  "an.badge": "الأغراض المفقودة",
  "an.title": "الأغراض المفقودة",
  "an.subtitle": "تصفّح الأغراض المفقودة التي أبلغ عنها المجتمع. هل وجدت واحدًا؟",
  "an.searchPh": "ابحث عن إعلان…",
  "an.none": "لا توجد إعلانات حاليًا.",
  "an.reward": "مكافأة",
  "an.lostAt": "فُقد في",
  "an.contact": "لقد وجدت هذا الغرض",
  "an.boosted": "مُروَّج",
  "an.remaining": "متبقٍ",
  "anf.claim": "هذا غرضي",
  "anf.claimTitle": "الإبلاغ بأن هذا غرضك",
  "anf.claimSent": "تم إرسال الرسالة إلى الواجد!",
  "an.contactTitle": "الإبلاغ بأنك وجدت هذا الغرض",
  "an.finderName": "اسمك",
  "an.finderEmail": "بريدك الإلكتروني",
  "an.finderPhone": "هاتفك",
  "an.message": "رسالة (اختياري)",
  "an.send": "إرسال",
  "an.sent": "تم إرسال الرسالة إلى المالك!",
  "an.copyLink": "نسخ الرابط",
  "an.linkCopied": "تم نسخ الرابط!",
  "an.copyFailed": "تعذّر نسخ الرابط",
  "rp.report": "إبلاغ",
  "rp.title": "الإبلاغ عن هذا الإعلان",
  "rp.reason": "السبب",
  "rp.comment": "تفاصيل (اختياري)",
  "rp.send": "إرسال البلاغ",
  "rp.sent": "شكرًا، تم إرسال بلاغك.",
  "rp.spam": "بريد مزعج / إعلان",
  "rp.offensive": "محتوى مسيء",
  "rp.fraud": "احتيال / نصب",
  "rp.other": "أخرى",
  "bo.title": "ترويج الإعلان",
  "bo.subtitle": "ضع إعلانك في صدارة القائمة مع شارة مرئية.",
  "bo.pay": "ادفع وروّج",
  "bo.active": "الترويج نشط",
  "bo.remaining": "الوقت المتبقي",
  "bo.renew": "تجديد الترويج",
  "ad.edit": "تعديل",
  "ad.close": "إغلاق",
  "ad.closeConfirm": "إغلاق هذا الإعلان؟",
  "ad.boost": "ترويج",
  "ad.saved": "تم تعديل الإعلان",
  "ad.closed": "تم إغلاق الإعلان",
  "ad.editTitle": "تعديل الإعلان",
  "cd.d": "ي",
  "cd.h": "س",
  "cd.m": "د",
  "cd.expired": "منتهٍ",
  "bo.since": "منذ الترويج",
  "mc.statsTitle": "الإحصاءات",
  "mc.views": "المشاهدات",
  "mc.contacts": "الاتصالات",
  "mc.boostViews": "المشاهدات (ترويج)",
  "mc.boostContacts": "الاتصالات (ترويج)",
  "mc.share": "مشاركة",
  // app — partner detail (pd)
  "pd.back": "كل الشركاء",
  "pd.declare": "الإبلاغ عن فقدان هنا",
  "pd.reviews": "تقييمات العملاء",
  "pd.noReviews": "لا توجد تقييمات حاليًا.",
  "pd.itemsReturned": "أغراض مُعادة",
  "pd.itemsTotal": "أغراض مسجّلة",
  "pd.certified": "شريك معتمد",
  "pd.about": "حول",
  "pd.notFound": "الشريك غير موجود.",
  "pd.verifiedEstablishment": "مؤسسة موثّقة من Findloop",
  "mc.privacy": "الخصوصية والبيانات",
  "mc.privacyDesc": "حمّل نسخة من كل بياناتك الشخصية التي يحتفظ بها Findloop (اللائحة العامة لحماية البيانات، المادتان 15 و20).",
  "mc.exportData": "تحميل بياناتي (RGPD)",
  "mc.exporting": "جارٍ التحضير…",
  "mc.exportDone": "تم تحميل بياناتك.",
  "pd.map": "الموقع",
  "pd.recentItems": "أحدث الأغراض الموجودة",
  "pd.noItems": "لا يوجد غرض موجود مؤخرًا.",
  "pd.verified": "تقييم موثّق",
  "pd.reply": "رد المؤسسة",
  "mc.deleteAccount": "حذف حسابي",
  "mc.deleteDesc": "يحذف حسابك نهائيًا ويجعل بياناتك الشخصية مجهولة. هذا الإجراء لا رجعة فيه.",
  "mc.deleteConfirmTitle": "حذف حسابك؟",
  "mc.deleteConfirmBody": "سيُحذف حسابك نهائيًا وستصبح بياناتك الشخصية مجهولة. لا يمكن التراجع عن هذا الإجراء.",
  "mc.deleteConfirm": "نعم، احذف حسابي",
  "mc.deleting": "جارٍ الحذف…",
  "mc.deleted": "تم حذف حسابك.",
  "mc.cancel": "إلغاء",
  // app — cookies
  "ck.msg": "نستخدم ملفات تعريف الارتباط لحسن سير الموقع وقياس الجمهور.",
  "ck.accept": "قبول",
  "ck.refuse": "رفض",
  "ck.learn": "اعرف المزيد",
  "ck.acceptAll": "قبول الكل",
  "ck.customize": "تخصيص",
  "ck.save": "حفظ اختياراتي",
  "ck.manage": "إدارة ملفات تعريف الارتباط",
  "ck.title": "تفضيلات ملفات تعريف الارتباط",
  "ck.necessary": "ضرورية",
  "ck.necessaryDesc": "لا غنى عنها لعمل الموقع. نشطة دائمًا.",
  "ck.measurement": "قياس الجمهور",
  "ck.measurementDesc": "إحصاءات مجهولة لتحسين الخدمة.",
  "ck.saved": "تم حفظ التفضيلات",
  // app — post ad / found
  "an.post": "نشر إعلان",
  "an.postTitle": "الإبلاغ عن غرض مفقود",
  "an.postSubtitle": "صف غرضك المفقود — يساعدك المجتمع وشركاؤنا في العثور عليه.",
  "anf.badge": "الأغراض الموجودة",
  "anf.title": "إعلانات الأغراض الموجودة",
  "anf.subtitle": "تصفّح الأغراض الموجودة التي أبلغ عنها المجتمع. هل تعرّفت على غرضك؟",
  "anf.post": "نشر غرض موجود",
  "anf.postTitle": "الإبلاغ عن غرض موجود",
  "anf.postSubtitle": "صف الغرض الذي وجدته — ساعد مالكه على استعادته.",
  "anf.foundDate": "تاريخ العثور",
  "anf.foundAt": "وُجد في",
  "anf.publishFound": "نشر إعلان الغرض الموجود",
  "anf.published": "تم نشر إعلان الغرض الموجود",
  "anf.consent": "أوافق على أن يرى المالك بيانات التواصل الخاصة بي لاستعادة غرضه.",
  "nav.found": "الأغراض الموجودة",
  "anf.pointsEarned": "شكرًا! لقد ربحت للتو نقاط بطل الواجدين.",
  "anf.pointsPending": "ستُضاف نقاطك خلال 24 ساعة بعد التحقق.",
  "anf.loginRequired": "سجّل الدخول لنشر غرض موجود",
  "anf.loginDesc": "يلزم حساب واجد لنشر إعلان وكسب نقاط بطل الواجدين.",
  "anf.loginCta": "تسجيل الدخول / إنشاء حساب",
  "anf.publishedAs": "نُشر باسم",
  "fp.hero": "بطل الواجدين",
  "anf.photo": "صورة الغرض",
  "mc.myFoundAds": "إعلاناتي عن الأغراض الموجودة",
  "mc.foundAdsNone": "لا يوجد إعلان غرض موجود منشور.",
  "mc.closeAd": "إغلاق",
  "mc.adClosed": "تم إغلاق الإعلان",
  "mc.closeAdConfirm": "إغلاق هذا الإعلان؟ لن يعود مرئيًا وسيحرّر مكانًا.",
  "mc.pointsAwaiting": "نقاط قيد الانتظار",
  "mc.pointsOk": "نقاط مُضافة",
  "map.mAll": "الكل",
  "map.mLost": "مفقودة",
  "map.mFound": "موجودة",
  "mc.declareLost": "الإبلاغ عن فقدان",
  "mc.declareLostSub": "نشر إعلان غرض مفقود",
  "mc.declareFound": "الإبلاغ عن غرض موجود",
  "mc.declareFoundSub": "نشر غرض وجدته",
  "mc.matches": "التطابقات",
  "mc.matchesSub": "قد تتطابق أغراض موجودة مع إعلانات فقدانك.",
  "mc.forYourAd": "لإعلانك",
  "mc.matchPublic": "غرض موجود",
  "mc.matchPartner": "لدى شريك",
  "mc.connect": "الربط",
  "mc.changePhoto": "تغيير الصورة",
  "mc.photoUpdated": "تم تحديث صورة الملف الشخصي",
  "an.date": "تاريخ الفقدان",
  "an.photo": "صورة (اختياري)",
  "an.publish": "نشر الإعلان",
  "an.publishing": "جارٍ النشر…",
  "an.published": "تم نشر الإعلان!",
  "an.boostPrompt": "روّج إعلانك ليكون في صدارة القائمة وتُعثر عليه أسرع.",
  "an.boostNow": "روّج الآن",
  "an.boostLater": "لاحقًا",
  "an.loginToBoost": "سجّل الدخول لترويج هذا الإعلان",
  "an.goAccount": "عرض حسابي",
};

// ── Simplified Chinese — full dictionary ────────────────────────────────────
const zh = {
  "rev.eyebrow": "用户评价",
  "rev.title": "他们信赖 Findloop",
  "rev.subtitle": "合作伙伴与客户分享他们的体验。",
  "rev.b2b": "B2B 合作伙伴",
  "rev.b2c": "客户",
  "rev.verified": "已验证",
  "rev.based": "基于 {n} 条评价",
  "nav.partners": "合作伙伴",
  "nav.track": "追踪申报",
  "nav.how": "工作原理",
  "nav.pricing": "价格",
  "nav.login": "登录",
  "nav.register": "成为合作伙伴",
  "nav.dashboard": "我的空间",
  "hero.badge": "精选",
  "hero.title": "每一件失物都能回到失主手中。",
  "hero.subtitle": "Findloop 帮助机构管理失物招领——并让其客户申报遗失、随后取回物品，可现场领取或邮寄。",
  "hero.ctaPartner": "成为合作伙伴",
  "hero.ctaLost": "我丢失了物品",
  "hero.ctaFound": "我捡到了物品",
  "lost.title": "您丢失了物品吗？",
  "lost.desc": "选择您希望的处理方式。",
  "lost.b2bTitle": "向合作伙伴申报",
  "lost.b2bDesc": "在酒店、交通工具或合作场所丢失？找到该机构并申报您的遗失。",
  "lost.b2cTitle": "发布公开启事",
  "lost.b2cDesc": "发布所有人可见的启事，提供悬赏并推广，以最大化找回机会。",
  "stat.partners": "合作伙伴",
  "stat.items": "已登记物品",
  "stat.restituted": "已归还物品",
  "how.eyebrow": "工作原理",
  "how.title": "从存放到归还，尽在简单几步。",
  "step1.tag": "机构",
  "step1.title": "合作伙伴登记物品",
  "step1.text": "几秒内，机构即可上传失物的照片、类别和描述。所有信息集中于清晰安全的登记簿中。",
  "step2.tag": "客户",
  "step2.title": "客户申报遗失",
  "step2.text": "通过合作伙伴的二维码，您的客户 30 秒内即可描述遗失物品。无需安装应用，全程在浏览器完成。",
  "step3.tag": "智能",
  "step3.title": "AI 将遗失与失物相匹配",
  "step3.text": "我们的智能匹配引擎比对描述，提出最可能的匹配结果，随时可确认。",
  "step4.tag": "取回",
  "step4.title": "客户取回物品",
  "step4.text": "安全支付取回费用后，客户可现场领取物品——或通过可追踪的邮寄收取。",
  "promo.badge": "合作伙伴计划",
  "promo.title": "推荐好友，赠送一个月。",
  "promo.text": "您推荐并订阅的每位合作伙伴都会为您赠送一个月免费。不设上限。",
  "promo.cta": "了解更多",
  "feat1.t": "仪表盘与分析",
  "feat1.d": "关键指标、按类别的归还率、30 天收入与趋势。",
  "feat2.t": "邮寄模块",
  "feat2.d": "标签、承运商追踪与自动追踪邮件。",
  "feat3.t": "公开目录与评价",
  "feat3.d": "客户可按城市和类别找到您，并附带认证评价。",
  "pricing.eyebrow": "价格",
  "pricing.title": "为每种机构提供方案",
  "pricing.subtitle": "免费开始，按需升级。",
  "pricing.popular": "热门",
  "pricing.choose": "选择",
  "pricing.start": "开始",
  "pricing.month": "/月",
  "pricing.requestQuote": "申请报价",
  "pricing.quoteTitle": "申请报价",
  "pricing.quoteOrg": "机构",
  "pricing.quoteSites": "站点/终端数量",
  "pricing.quoteMsg": "您的需求（可选）",
  "pricing.quoteSend": "发送申请",
  "pricing.quoteSent": "申请已发送！我们会尽快与您联系。",
  "pricing.compareTitle": "比较方案",
  "pricing.compareFeature": "功能",
  "cmp.estIncl": "含机构数",
  "cmp.estSec": "附加机构",
  "cmp.items": "物品/月",
  "cmp.ai": "AI 匹配",
  "cmp.stats": "统计",
  "cmp.autobill": "自动开票",
  "cmp.members": "成员邀请",
  "cmp.consol": "合并开票",
  "cmp.deploy": "专属部署与 SLA",
  "cmp.support": "支持",
  "cmp.main": "1 个主机构",
  "cmp.upTo3": "最多 3 个",
  "cmp.unlimited": "无限制",
  "cmp.onQuote": "按报价",
  "cmp.max20": "最多 20 个",
  "cmp.basic": "基础",
  "cmp.adv": "进阶",
  "cmp.statsBasic": "基础版",
  "cmp.statsAdv": "进阶版",
  "cmp.custom": "定制",
  "cmp.community": "社区",
  "cmp.priority": "优先",
  "cmp.dedicated": "专属",
  "cta.title": "准备好减少失物了吗？",
  "cta.subtitle": "加入借助 Findloop 更快归还失物的众多机构。",
  "cta.button": "创建我的合作伙伴账户",
  "lang.label": "语言",
  "nav.more": "更多",
  // app — common / declaration
  "c.loading": "加载中…",
  "c.reviews": "评价",
  "c.save": "保存",
  "c.cancel": "取消",
  "dec.notfound": "未找到该合作伙伴。",
  "dec.home": "返回首页",
  "dec.badge": "遗失申报",
  "dec.successTitle": "申报已发送！",
  "dec.successText": "我们正在以下机构的存放物品中寻找您的物品",
  "dec.matchFound": "已识别到一个匹配！",
  "dec.trackBtn": "追踪我的申报",
  "dec.recoverBtn": "取回我的物品",
  "dec.category": "物品类别",
  "dec.description": "描述",
  "dec.descPh": "描述物品：品牌、颜色、显著特征…",
  "dec.date": "遗失日期",
  "dec.place": "遗失地点",
  "dec.placePh": "例如：在酒吧、204 房间…",
  "dec.contactTitle": "您的联系方式",
  "dec.name": "全名",
  "dec.email": "电子邮箱",
  "dec.phone": "电话",
  "dec.submit": "发送我的申报",
  "dec.submitting": "发送中…",
  "par.badge": "目录",
  "par.title": "我们的合作伙伴",
  "par.subtitle": "找到您遗失物品的机构并申报您的遗失。",
  "par.searchPh": "搜索机构…",
  "par.allCountries": "所有国家",
  "par.certified": "已认证",
  "par.none": "未找到任何合作伙伴。",
  "par.certifiedBadge": "已认证",
  "par.partnerBadge": "合作伙伴",
  "par.declare": "申报",
  "trk.badge": "追踪",
  "trk.title": "追踪我的申报",
  "trk.subtitle": "输入您的申报编号以查看进度。",
  "trk.idLabel": "申报编号",
  "trk.emailLabel": "电子邮箱（可选——用于查看您的联系方式）",
  "trk.submit": "追踪",
  "trk.searching": "搜索中…",
  "trk.at": "在",
  "trk.recoverBtn": "取回我的物品",
  "trk.lostEmail": "我已无法访问我的邮箱",
  "trk.recoverHint": "通过短信在您注册的号码上接收认领码。",
  "trk.phonePh": "您的电话号码",
  "trk.send": "发送",
  "trk.secureRest": "安全归还",
  "trk.yourCode": "您的认领码（请出示给合作伙伴）",
  "trk.showQr": "向合作伙伴出示此二维码以确认交付",
  "trk.codeValidated": "认领码已由合作伙伴验证",
  "trk.enterEmailCode": "在上方输入您的邮箱以显示认领码。",
  "trk.photoBefore": "邮寄前的物品照片",
  "trk.signProof": "签署您的归还凭证",
  "trk.signSubmit": "确认签名并生成 PDF",
  "trk.dlProof": "下载我的归还凭证（PDF）",
  "trk.signFirst": "请先签名再确认。",
  "trk.sigSaved": "签名已保存",
  "pay.badge": "取回",
  "pay.title": "取回我的物品",
  "pay.subtitleWith": "向以下机构支付取回费用",
  "pay.fee": "取回费用",
  "pay.serviceFee": "Findloop 服务费",
  "pay.total": "合计",
  "pay.shipNote": "可邮寄",
  "pay.shipAfter": "——付款后提供。",
  "pay.noMatch": "尚未为此申报确认任何匹配物品。",
  "pay.card": "刷卡支付",
  "pay.momo": "使用 Mobile Money 支付",
  "pay.momoConfirm": "确认支付",
  "pay.phonePh": "电话号码",
  "pay.secure": "安全支付",
  "pay.notfound": "未找到该申报。",
  "pay.howRecover": "您希望如何取回物品？",
  "pay.pickup": "亲自领取",
  "pay.pickupDesc": "在",
  "pay.free": "免费",
  "pay.ship": "将物品邮寄给我",
  "pay.shipDesc": "配送至我的地址",
  "pay.shipping": "邮寄费用",
  "pay.addrIncomplete": "请填写您的配送地址。",
  "pay.addr1": "地址",
  "pay.addr2": "地址补充（可选）",
  "pay.postal": "邮政编码",
  "pay.city": "城市",
  "pay.country": "国家",
  "rate.title": "评价您的体验",
  "rate.subtitle": "您取回物品的过程如何？",
  "rate.commentPh": "评论（可选）…",
  "rate.submit": "提交我的评价",
  "rate.submitting": "发送中…",
  "rate.successTitle": "感谢您的评价！",
  "rate.successText": "您的反馈能帮助其他用户。",
  "rate.home": "返回首页",
  "rate.chooseNote": "请选择评分。",
  // app — auth
  "a.email": "电子邮箱",
  "a.password": "密码",
  "a.confirmPassword": "确认密码",
  "a.passwordMismatch": "两次密码不一致。",
  "a.loginTitle": "合作伙伴登录",
  "a.loginSub": "进入您的管理空间。",
  "a.login": "登录",
  "a.loggingIn": "登录中…",
  "a.forgot": "忘记了？",
  "a.or": "或",
  "a.rememberMe": "记住我",
  "a.noAccount": "还不是合作伙伴？",
  "a.createAccount": "创建账户",
  "a.registerTitle": "成为合作伙伴",
  "a.registerSub": "1 分钟创建您的空间——免费起步。",
  "a.org": "机构名称",
  "a.emailPro": "企业邮箱",
  "a.country": "国家",
  "a.city": "城市",
  "a.category": "类别",
  "a.categoryPlaceholder": "选择类别",
  "a.siret": "SIRET",
  "a.vat": "欧盟增值税号",
  "a.legalHint": "法国机构电子开票（Factur-X）所必需。",
  "a.legalRequiredFR": "在法国，SIRET 和欧盟增值税号为必填项。",
  "pcat.hotel": "酒店",
  "pcat.restaurant": "餐厅",
  "pcat.park": "公园",
  "pcat.city_hall": "市政厅",
  "pcat.prefecture": "省府",
  "pcat.other": "其他",
  "pcat.uncategorized": "未分类",
  "a.referral": "推荐码（可选）",
  "a.createBtn": "创建我的账户",
  "a.creating": "创建中…",
  "a.haveAccount": "已是合作伙伴？",
  "a.signin": "登录",
  "a.googleContinue": "使用 Google 继续",
  "a.googleSignup": "使用 Google 注册",
  "a.forgotTitle": "忘记密码",
  "a.forgotSub": "通过邮件接收重置链接。",
  "a.sendLink": "发送链接",
  "a.sending": "发送中…",
  "a.back": "返回",
  "a.forgotSent": "如账户存在，重置链接已发送。",
  "a.resetTitle": "新密码",
  "a.resetSub": "为您的账户设置新密码。",
  "a.newPassword": "新密码",
  "a.reset": "重置",
  "a.min6": "至少 6 个字符",
  // app — dashboard
  "db.registry.t": "物品登记簿",
  "db.registry.s": "存放在您机构的所有失物。",
  "db.deposit.t": "登记失物",
  "db.deposit.s": "添加照片、类别和描述。",
  "db.declarations.t": "遗失申报",
  "db.declarations.s": "通过您的二维码申报遗失的客户。",
  "db.stats.t": "统计",
  "db.stats.s": "您的关键绩效指标。",
  "db.team.t": "团队",
  "db.team.s": "邀请同事共同管理物品。",
  "db.account.t": "我的账户",
  "db.account.s": "管理您的机构、订阅和二维码。",
  "side.registry": "登记簿",
  "side.deposit": "登记物品",
  "side.declarations": "申报",
  "side.stats": "统计",
  "side.team": "团队",
  "side.account": "我的账户",
  "side.matchHistory": "AI 历史",
  "side.viewSite": "查看公开网站",
  "side.logout": "退出登录",
  "side.partner": "合作伙伴",
  "cat.placeholder": "选择类别",
  "shell.title": "把失物变成满意的客户。",
  "shell.f1t": "AI 智能匹配",
  "shell.f1d": "自动关联遗失与失物。",
  "shell.f2t": "仪表盘与收入",
  "shell.f2d": "实时跟踪归还率与收入。",
  "shell.f3t": "合作伙伴二维码",
  "shell.f3d": "您的客户 30 秒完成申报。",
  "cover.title": "封面照片",
  "cover.helper": "显示为您申报页与目录中的横幅。",
  "cover.none": "暂无封面照片",
  "cover.add": "添加",
  "cover.change": "更换",
  "cover.remove": "删除",
  "crop.title": "裁剪封面照片",
  "crop.desc": "按横幅比例（3:1）调整取景。拖动并缩放。",
  "crop.saving": "保存中…",
  // app — client account (mc)
  "mc.title": "我的账户",
  "mc.subtitle": "在一处跟踪您的所有申报。",
  "mc.loginTitle": "客户登录",
  "mc.registerTitle": "创建客户账户",
  "mc.name": "全名",
  "mc.email": "电子邮箱",
  "mc.phone": "电话",
  "mc.password": "密码",
  "mc.country": "国家",
  "mc.loginBtn": "登录",
  "mc.registerBtn": "创建我的账户",
  "mc.toRegister": "还没有账户？",
  "mc.toLogin": "已注册？",
  "mc.rememberMe": "记住我",
  "mc.forgotLink": "忘记密码？",
  "mc.forgotTitle": "忘记密码",
  "mc.forgotSend": "发送链接",
  "mc.forgotSent": "如该邮箱存在账户，重置链接已发送。",
  "mc.backToLogin": "返回登录",
  "mc.resetTitle": "新密码",
  "mc.resetSave": "重置我的密码",
  "mc.resetDone": "密码已更新。您可以登录了。",
  "mc.newPassword": "新密码",
  "mc.confirmPassword": "确认密码",
  "mc.passwordMismatch": "两次密码不一致。",
  "mc.resetExpired": "此重置链接无效或已过期。请在下方申请新链接。",
  "mc.logout": "退出登录",
  "mc.welcome": "您好",
  "mc.myDeclarations": "我的申报",
  "mc.none": "暂无申报。",
  "mc.track": "追踪",
  "mc.at": "在",
  // app — shipping
  "ship.badge": "邮寄",
  "ship.title": "将物品邮寄给我",
  "ship.subtitle": "填写您的配送地址。",
  "ship.notShippable": "此物品不可邮寄。",
  "ship.needPaid": "请先支付取回费用再申请邮寄。",
  "ship.addr1": "地址",
  "ship.addr2": "地址补充（可选）",
  "ship.postal": "邮政编码",
  "ship.city": "城市",
  "ship.country": "国家",
  "ship.weight": "预估重量（公斤）",
  "ship.submit": "申请邮寄",
  "ship.submitting": "发送中…",
  "ship.price": "邮寄费用",
  "ship.successTitle": "邮寄申请已发送！",
  "ship.successText": "合作伙伴将准备您的包裹。发货后会通知您。",
  "ship.notfound": "未找到该申报。",
  "db.reviews.t": "客户评价",
  "db.reviews.s": "公开回复您客户的评价。",
  "db.shipments.t": "邮寄",
  "db.shipments.s": "生成标签并跟踪待寄包裹。",
  "side.reviews": "客户评价",
  "side.shipments": "邮寄",
  "side.invoices": "发票",
  "side.refresh": "刷新",
  // app — invoices
  "inv.title": "我的发票",
  "inv.subtitle": "查看并下载您的发票和收据。",
  "inv.count": "发票",
  "inv.paid": "已付（€）",
  "inv.unpaid": "未付（€）",
  "inv.empty": "暂无发票。",
  "inv.issued": "开具于",
  "inv.due": "到期",
  "inv.paidOn": "支付于",
  "inv.statusPaid": "已支付",
  "inv.statusUnpaid": "未支付",
  "inv.invoicePdf": "发票 PDF",
  "inv.receipt": "收据",
  "inv.pay": "支付",
  "inv.all": "全部",
  "inv.allYears": "所有年份",
  "inv.noMatch": "此筛选下无发票。",
  "inv.exportCsv": "导出 CSV",
  "inv.reminders": "催款",
  "inv.remindersDesc": "为此发票发送的邮件和短信提醒。",
  "inv.remindersEmpty": "未发送任何催款。",
  "inv.rmDue": "到期提醒",
  "inv.rmManual": "手动催款",
  "inv.rmSms": "第 30 天短信催款",
  "inv.rmStage": "提醒",
  // app — reviews / shipments
  "prev.none": "暂无评价。",
  "prev.reply": "回复",
  "prev.editReply": "修改回复",
  "prev.yourReply": "您的回复",
  "prev.send": "发布回复",
  "prev.sending": "发布中…",
  "prev.replyPh": "撰写一条礼貌的回复…",
  "prev.published": "回复已发布",
  "shp.none": "暂无邮寄申请。",
  "shp.to": "收件人",
  "shp.label": "生成标签",
  "shp.download": "下载 PDF",
  "shp.tracking": "追踪单号",
  "shp.carrier": "承运商",
  "shp.setTracking": "保存追踪",
  "shp.status": "状态",
  "shp.generating": "生成中…",
  "shp.trackingSaved": "追踪已保存",
  "pr.shipBtn": "将物品邮寄给我",
  "mc.myFound": "已申报的失物",
  "mc.myAds": "我的遗失启事",
  "mc.foundNone": "暂无已申报的失物。",
  "mc.adsNone": "暂无遗失启事。",
  "mc.reward": "悬赏",
  "mc.foundAt": "拾获于",
  "mc.lostAt": "遗失于",
  // app — statuses
  "st.in_storage": "存放中",
  "st.matched": "已匹配",
  "st.paid": "已支付",
  "st.shipping_requested": "已申请邮寄",
  "st.shipped": "已发货",
  "st.restituted": "已归还",
  "st.pending": "待处理",
  "st.submitted": "已提交",
  "st.open": "进行中",
  "st.claimed": "已认领",
  "st.verified": "已验证",
  "st.second_chance": "第二次机会",
  "st.delivered": "已送达",
  "st.closed": "已关闭",
  "st.resolved": "已解决",
  "st.destroyed": "已销毁",
  "st.donated": "已捐赠（公益）",
  "st.auctioned": "已拍卖",
  "st.handed_to_authorities": "已移交当局",
  "nav.ads": "失物",
  "nav.map": "地图",
  "nav.ranking": "排行榜",
  // app — score / finder
  "mc.scoreTitle": "寻回者得分",
  "mc.scorePts": "分",
  "mc.scoreThisYear": "今年",
  "mc.seeRanking": "查看排行榜",
  "mc.confirmRestitution": "确认归还",
  "mc.restitutionConfirmed": "归还已确认。",
  "mc.scoreAwarded": "太棒了！寻回者得分 +1 🎉",
  "mc.scoreEarned": "获得积分",
  "mc.finderProfile": "寻回者资料（可选）",
  "mc.finderProfileDesc": "归还物品可赢取积分并出现在公开排行榜上。",
  "mc.addPhoto": "添加照片",
  "mc.remove": "移除",
  "mc.pseudo": "名字或昵称",
  "mc.city": "城市",
  "mc.optInTitle": "出现在公开排行榜",
  "mc.optInDesc": "自愿参与。您同意公开展示以下所选内容。可随时修改。",
  "mc.visLabel": "排行榜中可见的内容：",
  "mc.visPhoto": "头像",
  "mc.visName": "名字/昵称",
  "mc.visCity": "城市",
  "mc.visCountry": "国家",
  "mc.profileSettings": "公开资料与排行榜",
  "mc.profileSaved": "资料已更新。",
  "lb.badge": "年度排行榜",
  "lb.title": "最佳寻回者",
  "lb.subtitle": "每次归还都赢取积分。排行榜每年 1 月 1 日重置。",
  "lb.tabFinders": "寻回者",
  "lb.tabPartners": "机构",
  "lb.allCountries": "所有国家",
  "lb.cityPh": "按城市筛选…",
  "lb.empty": "此筛选暂无排行榜。",
  "lb.pts": "分",
  "lb.returned": "已归还",
  "lb.resetNote": "本年度排行榜——每年 1 月 1 日重置。",
  "fp.backToRanking": "返回排行榜",
  "fp.notFound": "资料不存在或为私密。",
  "fp.badge": "徽章",
  "fp.scoreYear": "积分（年度）",
  "fp.scoreTotal": "累计积分",
  "fp.tagline": "一位让世界更美好的诚实寻回者。",
  "fp.share": "分享此资料",
  "fp.shareText": "看看 {name} 的资料，Findloop 寻回者！",
  "lb.share": "分享排行榜",
  "lb.shareText": "来看看 Findloop 上最佳寻回者的排行榜！",
  "lb.champion": "🏆 年度冠军",
  "mc.pointsBalance": "可兑换积分",
  "mc.rewardsTitle": "兑换我的积分",
  "mc.rewardsDesc": "用积分兑换我们合作伙伴提供的优惠。余额：",
  "mc.rewardsNone": "暂无可用奖励。",
  "mc.redeem": "兑换",
  "mc.notEnough": "积分不足",
  "mc.rewardRedeemed": "已获得奖励！代码：",
  "mc.myRewards": "我获得的券",
  "mc.redUsed": "已使用",
  "mc.redReady": "待出示",
  "mc.redExpired": "已过期",
  "mc.expiresOn": "过期于",
  "mc.historyTitle": "我的积分记录",
  "mc.histEarned": "已归还物品",
  "mc.notifTitle": "通知",
  "mc.notifEmpty": "暂无通知。",
  "home.champTitle": "我们的最佳寻回者",
  "home.champSubtitle": "每归还一件物品都赢取积分。加入排行榜并赢取奖励。",
  "home.champCta": "查看排行榜",
  "home.champBecome": "成为寻回者",
  // app — map
  "map.filterCity": "城市或国家…",
  "map.allCategories": "所有类别",
  "map.clear": "重置",
  "map.fullscreen": "全屏",
  "map.exitFullscreen": "退出",
  "map.topPlaces": "热门地点",
  "map.heatmap": "热力图",
  "map.stats": "按城市统计",
  "map.statsTop": "前 5 地点（失物）",
  "map.statsTrend": "6 个月趋势",
  "map.periodAll": "全部时间",
  "map.period7": "近 7 天",
  "map.period30": "近 30 天",
  "map.period90": "近 90 天",
  "map.impactMonth": "本月已归还物品",
  "map.impactTotal": "累计已归还",
  // app — events
  "ev.created": "已创建申报",
  "ev.matched": "已识别匹配物品",
  "ev.paid": "取回费用已支付",
  "ev.shipping_requested": "已申请邮寄",
  "ev.shipping_paid": "邮寄费用已支付",
  "ev.shipped": "包裹已发货",
  "ev.pickup": "现场领取",
  // app — announcements
  "an.badge": "失物",
  "an.title": "失物",
  "an.subtitle": "浏览社区申报的失物。您捡到了其中之一吗？",
  "an.searchPh": "搜索启事…",
  "an.none": "暂无启事。",
  "an.reward": "悬赏",
  "an.lostAt": "遗失于",
  "an.contact": "我捡到了这件物品",
  "an.boosted": "已推广",
  "an.remaining": "剩余",
  "anf.claim": "这是我的物品",
  "anf.claimTitle": "申报这是您的物品",
  "anf.claimSent": "消息已发送给寻回者！",
  "an.contactTitle": "申报您捡到了这件物品",
  "an.finderName": "您的姓名",
  "an.finderEmail": "您的邮箱",
  "an.finderPhone": "您的电话",
  "an.message": "留言（可选）",
  "an.send": "发送",
  "an.sent": "消息已发送给失主！",
  "an.copyLink": "复制链接",
  "an.linkCopied": "链接已复制！",
  "an.copyFailed": "无法复制链接",
  "rp.report": "举报",
  "rp.title": "举报此启事",
  "rp.reason": "原因",
  "rp.comment": "补充说明（可选）",
  "rp.send": "发送举报",
  "rp.sent": "谢谢，您的举报已提交。",
  "rp.spam": "垃圾信息/广告",
  "rp.offensive": "冒犯性内容",
  "rp.fraud": "诈骗/欺诈",
  "rp.other": "其他",
  "bo.title": "推广启事",
  "bo.subtitle": "让您的启事置于列表顶部并带有醒目徽章。",
  "bo.pay": "支付并推广",
  "bo.active": "推广已激活",
  "bo.remaining": "剩余时间",
  "bo.renew": "续订推广",
  "ad.edit": "编辑",
  "ad.close": "关闭",
  "ad.closeConfirm": "关闭此启事？",
  "ad.boost": "推广",
  "ad.saved": "启事已修改",
  "ad.closed": "启事已关闭",
  "ad.editTitle": "编辑启事",
  "cd.d": "天",
  "cd.h": "时",
  "cd.m": "分",
  "cd.expired": "已过期",
  "bo.since": "自推广以来",
  "mc.statsTitle": "统计",
  "mc.views": "浏览量",
  "mc.contacts": "联系数",
  "mc.boostViews": "浏览量（推广）",
  "mc.boostContacts": "联系数（推广）",
  "mc.share": "分享",
  // app — partner detail
  "pd.back": "所有合作伙伴",
  "pd.declare": "在此申报遗失",
  "pd.reviews": "客户评价",
  "pd.noReviews": "暂无评价。",
  "pd.itemsReturned": "已归还物品",
  "pd.itemsTotal": "已登记物品",
  "pd.certified": "认证合作伙伴",
  "pd.about": "关于",
  "pd.notFound": "未找到该合作伙伴。",
  "pd.verifiedEstablishment": "Findloop 认证机构",
  "mc.privacy": "隐私与数据",
  "mc.privacyDesc": "下载 Findloop 保存的您的全部个人数据副本（GDPR 第 15 及 20 条）。",
  "mc.exportData": "下载我的数据（GDPR）",
  "mc.exporting": "准备中…",
  "mc.exportDone": "您的数据已下载。",
  "pd.map": "位置",
  "pd.recentItems": "最新失物",
  "pd.noItems": "近期暂无失物。",
  "pd.verified": "已验证评价",
  "pd.reply": "机构回复",
  "mc.deleteAccount": "删除我的账户",
  "mc.deleteDesc": "永久删除您的账户并对您的个人数据进行匿名化。此操作不可撤销。",
  "mc.deleteConfirmTitle": "删除您的账户？",
  "mc.deleteConfirmBody": "您的账户将被永久删除，个人数据将被匿名化。此操作无法撤销。",
  "mc.deleteConfirm": "是的，删除我的账户",
  "mc.deleting": "删除中…",
  "mc.deleted": "您的账户已删除。",
  "mc.cancel": "取消",
  // app — cookies
  "ck.msg": "我们使用 Cookie 以保证网站正常运行并进行访问量统计。",
  "ck.accept": "接受",
  "ck.refuse": "拒绝",
  "ck.learn": "了解更多",
  "ck.acceptAll": "全部接受",
  "ck.customize": "自定义",
  "ck.save": "保存我的选择",
  "ck.manage": "管理 Cookie",
  "ck.title": "您的 Cookie 偏好",
  "ck.necessary": "必要",
  "ck.necessaryDesc": "网站运行所必需。始终启用。",
  "ck.measurement": "访问量统计",
  "ck.measurementDesc": "用于改进服务的匿名统计。",
  "ck.saved": "偏好已保存",
  // app — post ad / found
  "an.post": "发布启事",
  "an.postTitle": "申报一件失物",
  "an.postSubtitle": "描述您遗失的物品——社区和我们的合作伙伴将帮您找回。",
  "anf.badge": "失物招领",
  "anf.title": "招领启事",
  "anf.subtitle": "浏览社区申报的失物招领。认出您的物品了吗？",
  "anf.post": "发布招领",
  "anf.postTitle": "申报一件拾获物品",
  "anf.postSubtitle": "描述您捡到的物品——帮助失主取回。",
  "anf.foundDate": "拾获日期",
  "anf.foundAt": "拾获于",
  "anf.publishFound": "发布招领启事",
  "anf.published": "招领启事已发布",
  "anf.consent": "我同意失主可查看我的联系方式以取回其物品。",
  "nav.found": "失物招领",
  "anf.pointsEarned": "谢谢！您刚刚赢得了寻回英雄积分。",
  "anf.pointsPending": "您的积分将在核实后 24 小时内到账。",
  "anf.loginRequired": "登录以发布招领",
  "anf.loginDesc": "需要寻回者账户才能发布启事并赢取寻回英雄积分。",
  "anf.loginCta": "登录/创建账户",
  "anf.publishedAs": "发布身份",
  "fp.hero": "寻回英雄",
  "anf.photo": "物品照片",
  "mc.myFoundAds": "我的招领启事",
  "mc.foundAdsNone": "暂无已发布的招领启事。",
  "mc.closeAd": "关闭",
  "mc.adClosed": "启事已关闭",
  "mc.closeAdConfirm": "关闭此启事？它将不再可见并释放一个名额。",
  "mc.pointsAwaiting": "待到账积分",
  "mc.pointsOk": "已到账积分",
  "map.mAll": "全部",
  "map.mLost": "遗失",
  "map.mFound": "拾获",
  "mc.declareLost": "申报遗失",
  "mc.declareLostSub": "发布失物启事",
  "mc.declareFound": "申报拾获",
  "mc.declareFoundSub": "发布您捡到的物品",
  "mc.matches": "匹配",
  "mc.matchesSub": "可能有失物与您的遗失启事相匹配。",
  "mc.forYourAd": "针对您的启事",
  "mc.matchPublic": "失物",
  "mc.matchPartner": "在合作伙伴处",
  "mc.connect": "建立联系",
  "mc.changePhoto": "更换照片",
  "mc.photoUpdated": "头像已更新",
  "an.date": "遗失日期",
  "an.photo": "照片（可选）",
  "an.publish": "发布启事",
  "an.publishing": "发布中…",
  "an.published": "启事已发布！",
  "an.boostPrompt": "推广您的启事，使其置顶并更快被找到。",
  "an.boostNow": "立即推广",
  "an.boostLater": "稍后",
  "an.loginToBoost": "登录以推广此启事",
  "an.goAccount": "查看我的账户",
};

export const EXTRA = { pt, ar, zh };
